export default "__VITE_ASSET__e89c4357__"